<template>
  <div :class="{'d-none': !visible, 'd-md-block': visible}" class="sidebar">
    <div class="sidebar-inner bg-primary">
      <div class="p-1 h-100">
        <div class="d-flex flex-column h-100">
          <div v-if="user && user.email_verified_at">
            <template v-if="authenticated">
              <o-sidebar-children v-if="secondaryNavItems" :nav-items="secondaryNavItems" child-classes="nav"
                                  classes="nav nav-pills" li-classes="nav-item"></o-sidebar-children>
            </template>
          </div>
          <div v-if="authenticated" class="mt-auto">
            <ul class="nav nav-pills">
              <li class="nav-item">
                <router-link :to="{ name: 'settings.profile' }" class="nav-link">
                  {{ $t('core.settings') }}
                </router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#" @click.prevent="logout">
                  {{ $t('core.logout') }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'o-secondary-sidebar',
  props: ['visible'],

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/check',
      secondaryNavItems: 'navigation/secondaryNavItems',
      user: 'auth/user'
    })
  }
}
</script>
